// useFetchChannelCategories.js
import axios from "axios";
import useGetImages from "./useGetImages";

const useGetChannelCategories = () => {
  // Hooks
  const { getImages } = useGetImages();

  const getChannelCategories = async () => {
    try {
      const response = await axios.get(window.location.origin + "/wp-json/wp/v2/kanal_kategorier?per_page=50");

      // Extracting data from response
      const data = response.data;

      // Remapping object
      const channelCategories = [
        ...data.map((channelCategory) => ({
          id: channelCategory.id,
          parentId: channelCategory.parent,
          title: channelCategory.name,
          slug: channelCategory.slug,
          type: channelCategory.taxonomy,
        })),
      ];

      return channelCategories;
    } catch (error) {
      // Handle error here
      console.error("Error fetching channel categories:", error);
      // You can throw the error or return a default value, depending on your use case
      return null;
    }
  };

  return { getChannelCategories };
};

export default useGetChannelCategories;
